/** Formatting for the Money section. Cents everywhere; strings only at the edge. */

/** Cents → "$1,234.56". */
export function money(cents: number | null | undefined, opts: { sign?: boolean } = {}): string {
  if (cents == null) return '—';
  const negative = cents < 0;
  const body = (Math.abs(cents) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const prefix = negative ? '−$' : opts.sign ? '+$' : '$';
  return `${prefix}${body}`;
}

/** Whole dollars, for headline figures where cents are noise. */
export function dollars(cents: number | null | undefined, opts: { sign?: boolean } = {}): string {
  if (cents == null) return '—';
  const negative = cents < 0;
  const body = Math.round(Math.abs(cents) / 100).toLocaleString();
  return `${negative ? '−$' : opts.sign ? '+$' : '$'}${body}`;
}

/** Fallback label for a category path when the tree isn't loaded: "lifestyle.video_games" → "Video games". */
export function leafLabel(path: string | null | undefined): string {
  const last = (path ?? 'uncategorized').split('.').pop() ?? 'uncategorized';
  const s = last.replace(/[_-]+/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function isUncategorized(c: string | null | undefined): boolean {
  return !c || c === 'uncategorized';
}

/** "Today", "Yesterday", "Mon, Oct 5". */
export function dayLabel(ymd: string): string {
  const d = new Date(`${ymd}T12:00:00`);
  const today = new Date();
  const diff = Math.round((new Date(today.toDateString()).getTime() - new Date(d.toDateString()).getTime()) / 86_400_000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  return d.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: d.getFullYear() === today.getFullYear() ? undefined : 'numeric',
  });
}

export function shortDate(iso: string): string {
  return new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** 'YYYY-MM' → "Oct" (or "Oct '25" when not this year). */
export function monthLabel(ym: string): string {
  const d = new Date(`${ym}-15T12:00:00`);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString(undefined, { month: 'short', ...(sameYear ? {} : { year: '2-digit' }) });
}
